import { ref, Ref } from "vue"

const isDisplayAccomodationPopup: Ref<boolean> = ref(true)

export default isDisplayAccomodationPopup